import { Outlet } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Badge } from "primereact/badge";
import { AppMenu } from "components/AppMenu";
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { Link } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { SplitButton } from "primereact/splitbutton";
import LogoIcon from "assets/icons/logo_icon.png";
import PrimeReact from "primereact/api";
import useApp from "hooks/useApp";
import useAuth from "hooks/useAuth";
import { Dropdown } from "primereact/dropdown";
import Search from "./Search";
import { useTranslation } from "react-i18next";

const MainLayout = ({ organisations, setSelectedOrg, selectedOrg }) => {
  const auth = useAuth();
  const app = useApp();
  const appName = process.env.REACT_APP_NAME;
  const { t } = useTranslation();
  const MY_ACCOUNT = t("MY_ACCOUNT");
  const LOG_OUT = t("LOG_OUT");
  const FILTER_BY_FACILITY = t("FILTER_BY_FACILITY");
  const [staticMenuInactive, setStaticMenuInactive] = useState(false);
  const [overlayMenuActive, setOverlayMenuActive] = useState(false);
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
  const [currentDateTime, setCurrentDateTime] = useState("");

  PrimeReact.ripple = true;
  let menuClick = false;
  let mobileTopbarMenuClick = false;
  const layoutMode = "static";
  const isDesktop = () => {
    return window.innerWidth >= 992;
  };

  const handleOrganisationChange = (e) => {
    const selectedOrgVal = e.value;
    setSelectedOrg(selectedOrgVal); // Passing selected organization to parent component
  };

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      const date = `${(now.getDate() < 10 ? "0" : "") + now.getDate()}/${
        (now.getMonth() < 9 ? "0" : "") + (now.getMonth() + 1)
      }/${now.getFullYear()}`;
      const time = `${now.toLocaleTimeString()}`;
      setCurrentDateTime(`${date} ${time}`);
    };

    updateDateTime();
    const intervalId = setInterval(updateDateTime, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const onWrapperClick = (event) => {
    if (!menuClick) {
      setOverlayMenuActive(false);
      setMobileMenuActive(false);
    }

    if (!mobileTopbarMenuClick) {
      setMobileTopbarMenuActive(false);
    }

    mobileTopbarMenuClick = false;
    menuClick = false;
  };

  const onToggleMenuClick = (event) => {
    menuClick = true;
    if (isDesktop()) {
      if (layoutMode === "overlay") {
        if (mobileMenuActive === true) {
          setOverlayMenuActive(true);
        }
        setOverlayMenuActive((prevState) => !prevState);
        setMobileMenuActive(false);
      } else if (layoutMode === "static") {
        setStaticMenuInactive((prevState) => !prevState);
      }
    } else {
      setMobileMenuActive((prevState) => !prevState);
    }
    event.preventDefault();
  };

  const navbarSideLeftmost = useMemo(
    () => app.menus.navbarSideLeft,
    [app.menus]
  );
  const [navbarSideLeft, setNavbarSideLeft] = useState(
    navbarSideLeftmost[0].childNavbar
  );

  useEffect(() => {
    if (["/dashboard", "/home"].includes(window.location.pathname)) {
      setNavbarSideLeft(navbarSideLeftmost[0].childNavbar);
    } else {
      setNavbarSideLeft(navbarSideLeftmost[1].childNavbar);
    }
  }, [navbarSideLeftmost]);

  // useEffect(() => {
  //   setNavbarSideLeft(navbarSideLeftmost[0].childNavbar);
  // }, [navbarSideLeftmost]);

  const onSidebarClick = (e) => {
    menuClick = true;
  };
  const onMenuItemClick = (event) => {
    if (!event.item.items) {
      setOverlayMenuActive(false);
      setMobileMenuActive(false);
    }
    if (
      event &&
      event.item &&
      event.item.childNavbar &&
      event.item.childNavbar.length > 0
    ) {
      setNavbarSideLeft(event.item.childNavbar);
    }
    if (event && event.item && event.item.to === "/") {
      auth.logout();
    }
  };
  const navbarTopLeft = app.menus.navbarTopLeft;
  const navbarTopRight = app.menus.navbarTopRight;
  const wrapperClass = classNames("layout-wrapper", setContainerClass());

  function setContainerClass() {
    return {
      "layout-overlay": layoutMode === "overlay",
      "layout-static": layoutMode === "static",
      "layout-static-sidebar-inactive":
        staticMenuInactive && layoutMode === "static",
      "layout-overlay-sidebar-active":
        overlayMenuActive && layoutMode === "overlay",
      "layout-mobile-sidebar-active": mobileMenuActive,
      "p-input-filled": false,
    };
  }
  const appBarActionMenu = [
    {
      label: MY_ACCOUNT,
      icon: "pi pi-user",
      command: (event) => {
        app.navigate("/account");
      },
    },
    {
      label: LOG_OUT,
      icon: "pi pi-window-minimize",
      command: (event) => {
        auth.logout();
      },
    },
  ];
  if (auth.loading) {
    // full screen loading.
    // Loading current user data from api
    return (
      <div
        style={{ height: "100vh" }}
        className="flex align-items-center justify-content-center"
      >
        <ProgressSpinner />
      </div>
    );
  }

  if (auth.user) {
    return (
      <div className={wrapperClass} onClick={onWrapperClick}>
        <div
          className="layout-topbar"
          style={{
            boxShadow: "none",
            borderBottom: "2px solid #F0F0F0",
          }}
        >
          <div className="layout-toggle-menu col-2">
            <div
              onClick={onToggleMenuClick}
              style={{
                cursor: "pointer",
                marginLeft: "0px",
                marginRight: "-10px",
              }}
            >
              {/* <img src={LogoPlusIcon} /> */}
            </div>
            <Link to="/home" className="layout-topbar-logo flex-grow-none">
              <img src={LogoIcon} alt={appName} />
            </Link>
          </div>
          <div
            className="layout-topbar-menu col-3 justify-content-end"
            style={{ width: "60%" }}
          >
            {navbarTopLeft && (
              <div
                className={classNames("", {
                  "layout-topbar-menu-mobile-active": mobileTopbarMenuActive,
                })}
              >
                {navbarTopLeft.map((item, index) => (
                  <Link key={`top-left-menu-${index}`} to={item.to}>
                    <Button
                      label={item.label}
                      icon={item.icon}
                      className="p-button-text text-white page-button"
                    />
                  </Link>
                ))}
              </div>
            )}
            <Search />
            <Dropdown
              showClear
              filter
              emptyFilterMessage={t("NO_OPTIONS_FOUND")}
              value={selectedOrg}
              onChange={handleOrganisationChange}
              options={organisations}
              optionLabel="name"
              placeholder={FILTER_BY_FACILITY}
              appendTo="self"
              className="w-full md:w-14rem"
            />
            {navbarTopRight && (
              <div
                className={classNames("", {
                  "layout-topbar-menu-mobile-active": mobileTopbarMenuActive,
                })}
              >
                {navbarTopRight.map((item, index) => (
                  <Link key={`top-right-menu-${index}`} to={item.to}>
                    <Button
                      label={item.label}
                      icon={item.icon}
                      className="p-button-text text-white page-button"
                    />
                  </Link>
                ))}
              </div>
            )}
            {/* <i
              className="pi pi-bell"
              style={{
                fontSize: "1.5rem",
                position: "relative",
                cursor: "pointer",
              }}
            >
              <Badge
                severity="danger"
                style={{
                  position: "absolute",
                  right: "-2px",
                  top: "-2px",
                }}
              ></Badge>
            </i> */}
            <SplitButton
              className="layout-menu-user-button flex"
              appendTo="self"
              style={{
                width: "210px",
                height: "50px",
              }}
              icon={
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                  }}
                  // className="flex align-items-center"
                >
                  <label style={{ textAlign: "end" }}>
                    {t("HELLO")}, {auth.user.user}
                  </label>
                  {/* <br /> */}
                  <label>{currentDateTime}</label>
                </div>
              }
              model={appBarActionMenu}
            >
              <Link to="/account">
                {/* <img src={DrIcon} alt={drName} /> */}
                <Avatar
                  shape="circle"
                  className="bg-primary text-white"
                  size="large"
                  icon="pi pi-user"
                />
              </Link>
            </SplitButton>
          </div>
        </div>
        <div
          className="layout-sidebar leftmost-sidebar"
          onClick={onSidebarClick}
          style={{
            borderRight: "2px solid #F0F0F0",
          }}
        >
          <AppMenu
            model={navbarSideLeftmost}
            onMenuItemClick={onMenuItemClick}
          />
        </div>
        <div
          className="layout-sidebar left-sidebar"
          onClick={onSidebarClick}
          style={{
            borderRight: "2px solid #F0F0F0",
          }}
        >
          <AppMenu model={navbarSideLeft} onMenuItemClick={onMenuItemClick} />
        </div>
        <div
          className="layout-main-container"
          // style={{
          //   backgroundColor: "white",
          // }}
        >
          <div className="layout-main">
            <Outlet />
          </div>
        </div>
      </div>
    );
  }
};
export default MainLayout;
